/* eslint-disable max-statements */
/* jshint -W003 */

(function ($) {

  function productOnClickEvent() {
    var helpProduct = $(this);
    productOnClick(helpProduct);
  }

  function productOnClick(helpProduct) {
    var closeOnly = false;
    if (helpProduct.hasClass('active')) {
      closeOnly = true;
    }

    var previous = $('.help-product.active');
    if (previous.length) {
      previous.removeClass('active');
      previous.next('.list-group').slideUp(300);
      previous.find('.arrow-up').removeClass('arrow-up').addClass('arrow-down');
    }

    if (closeOnly) { return; }

    helpProduct.addClass('active');
    helpProduct.next('.list-group').slideDown(300);
    helpProduct.find('.arrow-down').removeClass('arrow-down').addClass('arrow-up');

    var item = helpProduct.attr('data-item');
    var id = helpProduct.attr('data-id');
    var name = helpProduct.attr('data-name');
    id = id.replace('Support:Product:Nav:', '');

    ux.traffic.click('mcx.help.product.nav.click',
      [
        ['item', item],
        ['id', id],
        ['name', name],
        ['prodId', requestContext.searchScopeStrId],
        ['prodName', requestContext.searchScope],
        ['plId', requestContext.plId]
      ]);
  }

  function productLinkOnClick(evt) {
    var product = $(evt.currentTarget);
    if (product.length) {
      setTimeout(function () {
        window.location.href = product.attr('data-href');
      }, 100);
    }
  }

  function productNavSectionChange(nav) {
    var activeNav = $('.help-product.active').attr('href');
    if (nav !== activeNav) {
      var newHelpProduct = $('.help-product[href="' + nav + '"]');
      if (newHelpProduct.length) {
        productOnClick(newHelpProduct);
      }
    }
  }

  function onHashChange() {
    var hash = window.location.hash;
    if (hash && hash.length > 1) {
      if (hash.indexOf('#nav-') !== -1) {
        productNavSectionChange(hash);
      }
    }
    return true;
  }

  function sendProductNavUxEvent() {
    var productId = requestContext.searchScopeId;
    ux.traffic.click('mcx.help.product.nav.ux', [
      ['split', ''],
      ['productId', productId],
      ['plId', requestContext.plId],
      ['market', requestContext.market],
      ['internal', requestContext.internalRequest]
    ]);
  }

  function ready() {
    var productPage = $('.help-products');
    if (productPage.length) {
      sendProductNavUxEvent();
    }
  }

  $('.help-product').on('click', productOnClickEvent);
  $('.help-product-link').on('click', productLinkOnClick);
  $(window).on('hashchange', onHashChange);
  $(document).ready(ready);

}(jQuery));

/* jshint +W003 */
